/**
 * Lock/unlock background scrolling for full-screen overlays (lightbox, modals).
 * These overlays are fixed over the viewport but don't stop the page underneath,
 * so we pause Lenis (or fall back to `overflow: hidden` when Lenis is off).
 *
 * Both drop the scrollbar, which would widen the content and shift the layout
 * (the visible "jump" on open/close). So we first pad the page by the
 * scrollbar's exact width to keep the content box the same size — a no-op with
 * overlay scrollbars, which take no layout space.
 *
 * @param {import('lenis').default|null} [lenis] - smooth-scroll instance to pause
 */
export function lockScroll(lenis) {
  const scrollbar = window.innerWidth - document.documentElement.clientWidth
  if (scrollbar > 0) {
    document.documentElement.style.paddingRight = `${scrollbar}px`
  }
  if (lenis) {
    lenis.stop()
  } else {
    document.documentElement.style.overflow = 'hidden'
  }
}

export function unlockScroll(lenis) {
  // Restoring the scrollbar (−width) and dropping the pad (+width) happen in the
  // same frame, so they cancel out — no shift back.
  if (lenis) {
    lenis.start()
  } else {
    document.documentElement.style.overflow = ''
  }
  document.documentElement.style.paddingRight = ''
}
